<!--
 Name: Delcode2.vue
 Description: View to display the delcode2 page.
 Created by: Lokeswari Madhusudhana on 2025-04-21
 Last edited by: Andjelka Popovic on 2026-01-23
-->

<template>
  <v-container fluid class="pa-0 full-width">
   <!-- hero graphic -->
    <div :style="{ backgroundColor: '#57509C', height: '750px' }">
      <v-row no-gutters>
        <!-- hero text -->
        <h1 class="hero-title text-white ml-12 pl-12 mt-12 pt-12">
          Willkommen zu <b>neotivTrials</b>, im Rahmen der DELCODE 2-Studie
        </h1>
        <v-col cols="11" md="5" offset="1">
          <v-row class="mt-2 pt-2" no-gutters>
            <v-col cols="11">
              <p class="hero-text text-white mt-12">

                Hier finden Sie wichtige Informationen zu den Studienphasen, in denen Sie die <strong>neotivTrials-App</strong> zur Durchführung von digitalen Gedächtnistests im Rahmen der DELCODE 2-Studie des Deutschen Zentrums für Neurodegenerative Erkrankungen (DZNE)verwenden.
              </p>
              <v-btn
                variant="flat"
                size="large"
                @click="scrollToInfoTrials"
                class="hero-text mt-12"
              >
                Zur Installation & Nutzung der neotivTrials-App
              </v-btn>
              <v-btn
                variant="flat"
                size="large"
                @click="scrollToSupport"
                class="hero-text mt-12"
              >
                Hilfe bei Fragen zur neotivTrials-App
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <!-- v-col in required to make it work on the smaller devices in safari -->
        <!-- hidden-sm-and-down doesn't work with d-flex -->
        <v-col
          v-if="$vuetify.display.mdAndUp"
          cols="6"
          class="justify-end d-flex"
        >
          <v-img
            :src="require('@/assets/images/delcode2/delcode2_herosection.png')" cover height="550px"
          />
        </v-col>
      </v-row>
    </div>

    <!-- Study Infos -->
    <section class="studyInfos bg-white">
      <v-container>
        <h1 class="text-left my-6">
          Alles Wichtige zur DELCODE 2-Studie & Ihren Tests mit neotivTrials
          <v-divider></v-divider>
        </h1>
        <v-row class="mt-6" no-gutters>
          <h2 class="text-left my-6">Was wird untersucht?</h2>
            <p class="text-justify">
              Die DELCODE 2-Studie des DZNE erforscht, wie sich das Gedächtnis und andere kognitive (geistige) Fähigkeiten über mehrere Jahre hinweg verändern. Ziel ist es, erste Anzeichen für Gedächtnisprobleme besser zu erkennen und neue Erkenntnisse über die Entstehung von Demenz-Erkrankungen zu gewinnen. Gleichzeitig soll die Studie dabei helfen, die Anwendbarkeit und den Nutzen digitaler Tests zur frühzeitigen Erkennung von möglichen kognitiven Beeinträchtigungen zu untersuchen.
            </p>
            <br>
            <p class="mb-2 text-justify">
              Um diese Veränderungen zu erfassen, werden unterschiedliche Testmethoden in verschiedenen Alters- und Risikogruppen eingesetzt. Dazu gehören Untersuchungen in den Studienzentren vor Ort (die Gedächtnisambulanzen des DZNE) sowie digitale Gedächtnistests mit der <strong>neotivTrials-App</strong>. Die App ermöglicht es, Ihre Gedächtnisleistung regelmäßig von zuhause aus und unter alltagsnahen Bedingungen zu messen – nicht nur einmal im Jahr im Studienzentrum. Dabei begleitet Sie <strong>neotivTrials</strong> während der gesamten Studie und legt einen besonderen Fokus auf das sogenannte episodische Gedächtnis – also die Fähigkeit, sich an persönliche Erlebnisse und Informationen zu erinnern.
            </p>
            <br>
            <p class="mb-2 text-justify">
              Dazu absolvieren Sie im Verlauf der Studie vier verschiedene Gedächtnistests in der App. Diese Tests werden über mehrere Jahre hinweg wiederholt. Durch diese regelmäßigen Testungen können nicht nur langfristige Veränderungen erkannt, sondern auch kurzfristige Schwankungen berücksichtigt werden. So erhält die Forschung wertvolle Erkenntnisse darüber, wie sich kognitive Funktionen im Alltag entwickeln und verändern.
            </p>
        </v-row>
        <v-row class="mt-6" no-gutters>
          <!-- Left Column -->
          <v-col cols="12" md="6" class="pr-md-8">
            <h2 class="text-left my-6">Was ist meine Aufgabe in der Studie?</h2>
            <p class="text-justify">
              Die DELCODE 2-Studie erstreckt sich über einen Zeitraum von fünf Jahren, wobei sich die neotivTrials Studienphasen jährlich wiederholen. Jede neotivTrials Studienphase dauert max. 11 Wochen, gefolgt von einer längeren Pause bis zur nächsten Phase.
            </p>
            <br>
            <p class="mb-2 text-justify">
              Als Studienteilnehmende(r) absolvieren Sie innerhalb einer Studienphase regelmäßig kurze Gedächtnistests und Fragebögen in der <strong>neotivTrials-App</strong>.
            </p>
            <br>
            <p class="mb-2 text-justify">
              Zusätzlich gibt es weitere Untersuchungen und Studienphasen, über die Sie von Ihrem Studienzentrum vor Ort informiert werden.
            </p>
          </v-col>

          <!-- Right Column -->
          <v-col cols="12" md="6" class="pl-md-8">
            <h2 class="text-left my-6">Wichtige Hinweise zur Nutzung der neotivTrials-App:</h2>
            <p class="mb-2 text-justify">Damit Ihre Testergebnisse möglichst aussagekräftig sind, beachten Sie bitte folgende Hinweise:</p>
            <ul class="ml-12 my-2">
              <li>Führen Sie die Tests mit neotivTrials <strong>regelmäßig, vollständig</strong> und <strong>zeitnah nach Freischaltung</strong> durch. </li>
              <li>Beachten Sie bitte die <a @click="scrollToTipps">Tipps zur Vorbereitung & Durchführung</a>, um optimale Ergebnisse zu erzielen.</li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Start your participation -->
    <section class="participation violet_light">
      <v-container>
        <h2 class="text-left my-6">
          So läuft Ihre Teilnahme an der Studie ab
          <v-divider></v-divider>
        </h2>
        <br>
        <p class="mb-2">Zu Beginn der Studie findet in Ihrem Studienzentrum vor Ort ein Einführungstermin statt. Dabei wird die <strong>neotivTrials-App</strong> gemeinsam mit dem Studienpersonal auf Ihrem Smartphone oder Tablet eingerichtet, und Sie erhalten eine Einweisung in die Nutzung.</p>
        <br>
        <v-img
          :src="require('@/assets/images/delcode2/Delcode_Ablauf_Figure.png')" width="100%" height="680px"
        />
        <br>
        <h3>Ablauf einer Studienphase</h3>
        <h4 class="text-left my-6">Woche 1–7: Gedächtnistests in der neotivTrials-App</h4>
        <ul class="ml-12 my-2">
          <li>Sie absolvieren zunächst die drei Gedächtnistests: <i><b>Unterschiede finden, Gegenstände merken</b></i> und <i><b> Drinnen & Draußen</b></i>, wobei jeder Test zweimal durchgeführt wird. Jeder Test ist nach Freischaltung 4 Tage verfügbar und verfällt anschließend. Zwischen den Tests liegen jeweils 3 Tage Pause. Im Idealfall schließen Sie diese Tests innerhalb von ca. 3 Wochen ab. Bei Bedarf kann der Testzeitraum durch die Nutzung der verfügbaren Pufferzeiten auf bis zu ca. 6 Wochen ausgedehnt werden.</li>
          <li>Anschließend absolvieren Sie frühstens in der <b>4. Woche</b> bzw. spätestens in der 7. Woche einmal täglich den Test <i><b>Unterschiede lernen</b></i> (insgesamt fünfmal). Jede Wiederholung des Tests ist nach Freischaltung 2 Tage verfügbar. </li>
          <li>Die genauen Zeitfenster und Anweisungen werden direkt in der neotivTrials-App angezeigt.</li>
          <li>Zusätzlich beantworten Sie in der App <b>Fragebögen zu Ihrem Alltag</b> und Ihrer Erfahrung mit den Tests.</li>
        </ul>

        <p class="text-left my-6"><b>Woche 8-26:</b> Längere Pause bis zur nächsten neotivTrials Studienphase,
          in der weitere Untersuchungen und Tests im Rahmen der Studie stattfinden.</p>

        <h4 class="text-left my-6">Ab Woche 27: Start der nächsten Studienphase</h4>
        <ul class="ml-12 my-2">
          <li>Die nächste Studienphase beginnt erneut mit Tests in der neotivTrials-App, diesmal jedoch ohne den Test <i><b>Lerne die Unterschiede</b></i> (Dauer: 6 Wochen).</li>
          <li>Einmal im Jahr wird in der App ein <strong>kurzer Seh-Check</strong> durchgeführt. Dabei wird geprüft, ob Sie die gezeigten Bilder auf Ihrem Gerät gut erkennen können.</li>
          <li>Danach bleibt die Studie bis zum Start der nächsten Phase pausiert.</li>
          <li>Mehr Infos zu den Tests finden Sie auch im Abschnitt <a @click="scrollToBlick">Alles auf einen Blick</a> sowie im Nutzerhandbuch.</li>
        </ul>

        <!-- needs graphic here -->
      </v-container>
    </section>

    <!-- Infos about neotivTrials -->
    <section class="infoNeotivTrials bg-white">
      <v-container>
        <h1 class="text-left my-6">
          Schritt-für-Schritt-Anleitung zur Nutzung der neotivTrials-App
          <v-divider></v-divider>
        </h1>
        <p class="mb-4">In den folgenden Videos zeigen wir Ihnen Schritt für Schritt, wie Sie die <b>neotivTrials-App</b> auf Ihrem Handy oder Tablet installieren, sich in die Studie einloggen und bei Problemen Hilfe über die App erhalten.</p>
        <p class="mb-8"><b>Hinweis:</b> Für die Installation benötigt Ihr Gerät als Betriebssystem mindestens <b>Android 9.0 oder iOS 15.0.</b> Falls Sie sich unsicher sind, können Sie in den <b>Einstellungen Ihres Geräts</b> nachsehen, welche Version Sie verwenden.</p>
        <h2>App installieren</h2>
        <p class="mb-2">Wählen Sie das passende Video für Ihr Gerät:</p>
        <v-row no-gutters>
          <!-- Left Column -->
          <v-col cols="12" md="6" class="pr-md-8">
            <h4 class="text-left my-6">Für Android-Geräte (Google Play Store):</h4>
            <div class="video-wrapper" @click="openVideo(downloadAndroidVideo)">
              <video
                class="inline-video"
                :src="downloadAndroidVideo"
                muted
                playsinline
              ></video>
            </div>
          </v-col>

          <!-- Right Column -->
          <v-col cols="12" md="6" class="pl-md-8">
            <h4 class="text-left my-6">Für iPhones & iPads (Apple App Store):</h4>
            <div class="video-wrapper" @click="openVideo(downloadAppleVideo)">
              <video
                class="inline-video"
                :src="downloadAppleVideo"
                muted
                playsinline
              ></video>
            </div>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <!-- Left Column -->
          <v-col cols="12" md="6" class="pr-md-8">
            <h2 class="text-left my-6">In die Studie einloggen</h2>
            <div class="video-wrapper" @click="openVideo(appStartVideo)">
              <video
                class="inline-video"
                :src="appStartVideo"
                muted
                playsinline
              ></video>
            </div>
          </v-col>

          <!-- Right Column -->
          <v-col cols="12" md="6" class="pl-md-8">
            <h2 class="text-left my-6">Hilfe in der App:</h2>
            <div class="video-wrapper" @click="openVideo(bugReportVideo)">
              <video
                class="inline-video"
                :src="bugReportVideo"
                muted
                playsinline
              ></video>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Tipps -->
    <section class="tipps bg-primary">
      <v-container>
        <h1 class="text-left my-6">Tipps zur Testdurchführung
          <v-divider></v-divider>
        </h1>
        <v-row class="ma-1" no-gutters>
          <!-- Left Column -->
          <v-col cols="12" md="6" class="pr-md-8">
            <h2 class="text-left my-6">Tipps zur Vorbereitung:</h2>
            <ul class="ml-12 my-2">
              <li>Begeben Sie sich in einen <b>ruhigen Raum</b>, in dem Sie sich konzentrieren können.</li>
              <li>Für die Tests brauchen Sie einen <b>hellen Bildschirm</b>, um die Bilder gut zu erkennen. Passen Sie, wenn nötig die Helligkeit Ihres Bildschirmes an.</li>
              <li>Falls Sie eine <b>Sehhilfe</b> benötigen, setzen Sie diese bitte ein/ auf.</li>
              <li>Aktivieren Sie <b>Push-Benachrichtigungen</b>, damit Sie die App an den nächsten Test erinnern kann.</li>
            </ul>
          </v-col>

          <!-- Right Column -->
          <v-col cols="12" md="6" class="pl-md-8">
            <h2 class="text-left my-6">Tipps zur optimalen Durchführung:</h2>
            <ul class="ml-12 my-2">
              <li>Die <b>Tests bestehen aus 2 Teilen</b> und einer Pause. Die gesamte benötigte Zeit wird in der App angezeigt. Zusätzlich schickt Ihnen die App eine Erinnerung an Ihren Test.</li>
              <li>Bitte führen Sie <b>immer beide Teile des Tests</b> in der angezeigten Gesamtzeit durch, damit Ihr Test ausgewertet werden kann und nicht verfällt.</li>
              <li>Bitte kehren Sie am Ende des Tests zum <b>Hauptbildschirm zurück</b>. Sie sehen auf dem Hauptbildschirm, wann es weitergeht.</li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- Alles auf einen Blick -->
    <section class="blick bg-white">
      <v-container>
        <h1 class="text-left my-6">
          Alles auf einen Blick
          <v-divider></v-divider>
        </h1>
        <p class="mb-2">Hier finden Sie nützliche Anleitungen und Dokumente zum Herunterladen:</p>
        <ul class="ml-12 my-2">
          <li>
            <a
              href="/static/pdfs/delcode_Übersicht_Studienablauf.pdf"
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              Übersicht Studienablauf
            </a>
          </li>
          <li>
            <a
              href="/static/pdfs/2026_neotivTrials_Nutzerhandbuch_DE.pdf"
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              Nutzerhandbuch zur App
            </a>
            inklusive Installationsanleitung und Erklärung der Gedächtnistests in der neotivTrials-App
          </li>
          <li>
            <a
              href="/static/pdfs/2026_neotivTrials_FAQs_DE.pdf"
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              FAQs
            </a>
          </li>
          <li>
            <a
              href="/static/pdfs/2025_neotivTrials_data_privacy_DE.pdf"
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              Datenschutzerklärung
            </a>
          </li>
        </ul>
      </v-container>
    </section>

    <!-- Support -->
    <section class="support bg-white">
      <v-container>
        <h1 class="text-left my-6">
          Technischer Support & Datenschutz
          <v-divider></v-divider>
        </h1>
        <p class="mb-2">Falls technische Probleme auftreten, können Sie diese direkt in der neotivTrials-App melden <b>(Menü > Hilfe > Problem melden)</b>. Ihr Anliegen wird automatisch an das Support-Team weitergeleitet, das sich um eine schnelle Lösung kümmert. Ihr Studienzentrum erhält zudem eine Benachrichtigung über den Bearbeitungsstatus und kann bei Bedarf mit Ihnen Rücksprache halten.</p>
        <p class="mb-2">Ihre Daten werden nach den höchsten Sicherheitsstandards verarbeitet. Alle Informationen werden verschlüsselt übertragen und ausschließlich auf Servern in Deutschland gespeichert. Falls keine Internetverbindung besteht, bleiben die Daten sicher auf Ihrem Gerät und werden automatisch nachträglich übertragen. Die App speichert keine persönlichen Daten, und die Zuordnung erfolgt ausschließlich über eine pseudonymisierte Studien-ID.</p>
        <p class="mb-2">Die neotivTrials-App entspricht den Datenschutzanforderungen der <b>DSGVO</b> und wurde extern auf Sicherheit geprüft.</p>
      </v-container>
    </section>

    <!-- Frequently Questions -->
    <section class="faq bg-white">
      <v-container>
        <h1 class="text-left mb-6">
          Häufig gestellte Fragen (FAQ)
          <v-divider></v-divider>
        </h1>
        <p class="mb-6">
          <a
            class="text-decoration-underline cursor-pointer"
            @click="scrollToBlick"
          >
            Hier</a> finden Sie Antworten auf häufig gestellte Fragen zur neotivTrials-App.
        </p>
        <v-expansion-panels>
          <v-expansion-panel
            title="Ich habe Probleme beim Einloggen in die neotivTrials-App, was kann ich tun?"
          >
          <v-expansion-panel-text>
            <v-row no-gutters>
              <v-col cols="12" class="py-6">
                <ul class="ml-12 my-2">
                  <li>Stellen Sie sicher, dass Sie den richtigen Studientyp für die Anmeldung ausgewählt haben. Wenn Sie nach der Installation gefragt werden, wofür Sie die App nutzen möchten, dann wählen Sie als Studienteilnehmende bitte <b>Studien (zugangsbeschränkt).</b></li>
                  <li>Prüfen Sie, ob Sie den <b>richtigen Zugangscode</b> eingegeben haben (diesen erhalten Sie von Ihrer Studienkoordination vor Ort).</li>
                  <li>Achten Sie auf die korrekte Schreibweise (z. B. Groß- und Kleinschreibung, Leerzeichen).</li>
                  <li>Falls Sie Ihr Passwort nicht mehr wissen, wenden Sie sich bitte an Ihre Studienkoordination.</li>
                </ul>
              </v-col>
            </v-row>
          </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel
            title="Die neotivTrials-App lässt sich nicht mehr öffnen, was kann ich tun?"
          >
          <v-expansion-panel-text>
            <v-row no-gutters>
              <v-col cols="12" class="py-6">
                <p class="mb-3">Schließen Sie die App vollständig auf Ihrem Gerät:</p>
                <p class="mb-3"><b>Auf iOS-Geräten:</b></p>
                <ul class="ml-12 my-2">
                  <li><b>iPhone X oder neuer:</b> Wischen Sie von unten nach oben und halten Sie den Finger kurz in der Mitte des Bildschirms.</li>
                  <li><b>Ältere iPhones:</b> Drücken Sie zweimal schnell die <b>Home-Taste.</b></li>
                  <li>Wischen Sie die neotivTrials-App nach oben aus dem Bildschirm, um sie vollständig zu schließen.</li>
                </ul>
                <p class="mb-3"><b>Auf Android-Geräten:</b></p>
                <ul class="ml-12 my-2">
                  <li>Öffnen Sie die Liste der zuletzt verwendeten Apps. Dazu entweder auf die <b>„Anwendungen“</b>-Taste tippen oder von unten nach oben wischen.</li>
                  <li>Suchen Sie die neotivTrials-App in der Liste und wischen Sie sie zur Seite oder tippen Sie auf das <b>„X“</b>.</li>
                </ul>
                <p class="mb-3">Falls die App weiterhin nicht startet, prüfen Sie bitte folgendes:</p>
                <ul class="ml-12 my-2">
                  <li>Haben Sie die neueste Version der neotivTrials-App installiert? Öffnen Sie den App Store oder Google Play Store und suchen Sie nach Updates.</li>
                  <li>Überprüfen Sie, ob Sie mit dem Internet verbunden sind.</li>
                  <li><b>Falls das Problem weiterhin besteht, deinstallieren Sie die App und laden Sie sie erneut herunter.</b> Manchmal kann eine fehlerhafte Installation verhindern, dass die App startet. (Siehe nächste Frage: „Wie kann ich die App deinstallieren und dann erneut installieren?“).</li>
                  <li>Sollten die Probleme bestehen bleiben, kontaktieren Sie uns per E-Mail: <a href="mailto:support@neotiv.com">support@neotiv.com</a></li>
                </ul>
              </v-col>
            </v-row>
          </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel title="Wie kann ich die App deinstallieren und dann erneut installieren?">
          <v-expansion-panel-text>
            <p class="mb-3"><b>Auf iOS-Geräten:</b></p>
            <ul class="ml-12 my-2">
              <li>Gehen Sie zu <b>Einstellungen > Allgemein > iPhone-Speicher</b>.</li>
              <li>Tippen Sie auf die <b>neotivTrials-App</b>, um weitere Informationen anzuzeigen.</li>
              <li>Wählen Sie <b>"App löschen"</b>.</li>
              <li>Öffnen Sie anschließend den <b>App Store</b> und laden Sie die neueste Version der App herunter.</li>
            </ul>
            <p class="mb-3"><b>Auf Android-Geräten:</b></p>
            <ul class="ml-12 my-2">
              <li>Öffnen Sie den <b>Google Play Store</b> auf Ihrem Android-Gerät.</li>
              <li>Tippen Sie oben rechts auf das <b>Profil-Symbol</b>.</li>
              <li>Wählen Sie <b>"Apps und Gerät verwalten"</b>.</li>
              <li>Suchen Sie die <b>neotivTrials-App</b> und wählen Sie sie aus.</li>
              <li>Tippen Sie auf <b>"Deinstallieren"</b>, um die App zu entfernen.</li>
              <li>Laden Sie nun die neueste Version der App aus dem <b>Google Play Store</b> herunter.</li>
            </ul>
          </v-expansion-panel-text>
          </v-expansion-panel>
          <v-expansion-panel title="Wie melde ich ein Problem mit der App und sende einen Fehlerbericht?">
          <v-expansion-panel-text>
            <p class="mb-3">Im Menü unter dem Punkt <b>"Hilfe"</b> können Sie uns Probleme mit der App melden. Für eine genaue Anleitung schauen Sie in das <b>Handbuch der App</b>, was Sie von Ihrer Studienkoordination erhalten haben sollten, unter „Hilfe bei Problemen mit der App: Wie melde ich ein technisches Problem?“.</p>
            <p class="mb-3">Je detaillierter Ihre Beschreibung des Problems ist, desto leichter kann unser Support-Team den Fehler nachverfolgen und beheben.</p>
            <p class="mb-3"><b>Wichtig:</b></p>
            <ul class="ml-12 my-2">
              <li>Unser Support-Team kümmert sich so schnell wie möglich um ihr Anliegen. Die weitere Kommunikation erfolgt über Ihre Studienkoordination vor Ort.</li>
            </ul>
            <p class="mb-3">Alternativ können Sie uns auch per E-Mail kontaktieren: <a href="mailto:support@neotiv.com">support@neotiv.com</a></p>
            <p class="mb-3">Falls Sie keinen Fehlerbericht aus der App senden können und uns per E-Mail kontaktieren, geben Sie bitte an, welches Gerät und Betriebssystem Sie nutzen, damit unser Support-Team Ihnen helfen kann. Bitte beschreiben Sie uns außerdem:</p>
            <ul class="ml-12 my-2">
              <li>Was genau ist das Problem?</li>
              <li>Bei welchem Schritt tritt das Problem genau auf?</li>
              <li>An welcher Studie nehmen Sie teil?</li>
            </ul>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel title="Ich kann die App nicht herunterladen, was kann ich tun?">
          <v-expansion-panel-text>
            <ul class="ml-12 my-2">
              <li>Stellen Sie sicher, dass Sie <b>"neotivTrials"</b> korrekt und vollständig in die Suchleiste eingeben. Falls Sie nur Teile des Namens eingeben, könnte die App möglicherweise nicht gefunden werden.</li>
              <li>Die App wird im App Store oder Google Play Store nur angezeigt, wenn Ihr Gerät die folgenden Systemanforderungen erfüllt:</li>
              <ul class="ml-12 my-2">
                <li><b>iOS:</b> Version <b>15.0 oder höher</b></li>
                <li><b>Android:</b> Version <b>9.0 oder höher</b></li>
                <li><b>Bildschirmgröße:</b> Mindestens <b>4,7 Zoll (12cm)</b></li>
              </ul>
            </ul>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel title="Ich bekomme keine Erinnerungen für den nächsten Test, was kann ich tun?">
          <v-expansion-panel-text>
            <p class="mb-3">
              Die neotivTrials-App erinnert Sie per <b>Push-Benachrichtigung</b> an bevorstehende Tests.
              Falls Sie keine Benachrichtigungen erhalten, gehen Sie bitte wie folgt vor:
            </p>
            <ul class="ml-12 my-2">
              <li>Prüfen Sie, ob Push-Benachrichtigungen für die neotivTrials-App auf Ihrem Gerät aktiviert sind (eine Beschreibung dazu finden Sie auch im <b>Handbuch der App</b>, was Sie von Ihrer Studienkoordination erhalten haben sollten, unter „Hilfe bei Problemen mit der App: Warum erhalte ich keine Mitteilungen (Erinnerungen) von der App“).</li>
              <li>Stellen Sie sicher, dass Sie eine aktive Internetverbindung haben.</li>
              <li>Starten Sie die App neu (siehe Seite 1: „Die neotivTrials-App lässt sich nicht mehr öffnen, was kann ich tun?“).</li>
            </ul>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel title="Wie laufen die Tests generell ab?">
          <v-expansion-panel-text>
            <p class="mb-3">Die Anzahl, Reihenfolge und Zeitpunkte der Gedächtnistests in der neotivTrials-App können je nach Studie variieren. Grundsätzlich gelten jedoch folgende Punkte:</p>
            <ul class="ml-12 my-2">
              <li><b>Jeder Test besteht aus zwei Teilen</b> mit einer kurzen Pause dazwischen. Die gesamte benötigte Zeit wird Ihnen in der App angezeigt.</li>
              <li>Achten Sie darauf, <b>beide Testteile innerhalb der vorgegebenen Zeit zu absolvieren</b>, da sie sonst verfallen und unvollständige Tests nicht ausgewertet werden können.</li>
              <li>Die App zeigt Ihnen immer an, wann der nächste Test fällig ist, und sendet automatisch Erinnerungen an bevorstehende Tests.</li>
              <li>Falls Sie einen Testtermin verpassen, <b>starten Sie den Test zum nächstmöglichen Zeitpunkt</b>. Läuft ein Test ab, bevor Sie ihn starten, kann er nicht nachgeholt werden und die entsprechenden Daten gehen verloren.</li>
              <li>Kehren Sie nach Abschluss eines Tests immer zum <b>Hauptbildschirm der App zurück</b>, um die Startzeit des nächsten Tests zu sehen.</li>
            </ul>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel title="Kann ich den nächsten Test auf später verschieben?">
          <v-expansion-panel-text>
            <p class="mb-3">
              In der neotivTrials-App können Sie immer sehen, wann der nächste Test geplant ist. Falls Sie zu diesem Zeitpunkt nicht teilnehmen können, haben Sie die Möglichkeit, den Test etwas später zu
              starten. Beginnen Sie ihn bitte zum nächstmöglichen Zeitpunkt, damit Sie im Zeitplan bleiben.
            </p>
            <p class="mb-3"><b>Beachten Sie, dass die Zeitfenster für einen späteren Start der Tests begrenzt sein können. Wenn dieses Zeitfenster abgelaufen ist, kann der Test nicht mehr gestartet werden und verfällt stattdessen.</b></p>
            <p class="mb-3">
              Es gibt keine Funktion in der App, um einen Test aktiv zu verschieben oder abzubrechen. Sie sollten
              also beide Teile des Tests innerhalb der vorgegebenen Zeit abschließen, nur dann können die Daten ausgewertet werden.
            </p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel title="Ich habe einen Test verpasst, was soll ich jetzt tun?">
          <v-expansion-panel-text>
            <p class="mb-3">
              Falls Sie einen Test nicht rechtzeitig abschließen konnten, setzen Sie den nächsten Test wie gewohnt fort.
              <b>Eine Wiederholung verpasster Tests ist nicht möglich</b>, daher ist es wichtig, die Tests regelmäßig innerhalb der vorgegebenen Zeit durchzuführen.
            </p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel title="Warum ist es nicht möglich, eine Eingabe/bereits gegebene Antwort noch einmal zu ändern, zum Beispiel, wenn man sich vertippt hat, aber noch genügend Zeit hätte, sich zu korrigieren?">
          <v-expansion-panel-text>
            <p class="mb-3">Einmal gegebene Antworten können nicht nachträglich geändert werden bei den Tests. Deshalb ist es wichtig, dass Sie sich vor dem Start mit dem Ablauf und den Antwortmöglichkeiten vertraut machen – dafür gibt es die Training-Tutorials zu Beginn der Tests, die Sie auch mehrmals wiederholen können.</p>
            <p class="mb-3"><b>Einige wenige Tippfehler sind jedoch kein Problem:</b> Die Tests bestehen immer aus mehreren Durchgängen und einzelne Fehler wirken sich nicht auf das Gesamtergebnis aus. Trotzdem sollten Sie versuchen, aufmerksam zu bleiben und sich möglichst selten zu vertippen.</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel title="Die verwendeten Bilder in den Gedächtnistests erscheinen manchmal unrealistisch oder künstlich. Warum werden diese Bilder so dargestellt und was trägt es dazu bei, um die kognitive Leistungsfähigkeit zu messen?">
          <v-expansion-panel-text>
            <p class="mb-3">Die Tests der neotivTrials-App sind so gestaltet, dass sie bestimmte kognitive Fähigkeiten erfassen (die episodische Gedächtnisleistung), die bei der Alzheimer Erkrankung früh betroffen sind, basierend auf den neusten wissenschaftlichen Erkenntnissen. Um genaue Ergebnisse zu erhalten, müssen die Bilder in den Tests bestimmten Anforderungen entsprechen, zum Beispiel den Schwierigkeitsgrad betreffend.</p>
            <p class="mb-3">Da die Tests außerdem meist mehrmals wiederholt werden, um zum Beispiel Veränderungen über die Zeit zu messen, und aus jeweils mehreren Durchgängen bestehen, wird eine hohe Anzahl von Bildern benötigt. Aus diesem Grund sind die Bilder in manchen der Tests computergeneriert, was auch eine gute Vergleichbarkeit erlaubt.</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel title="Wie kann ich generelles Feedback geben (zu der App oder den Studieninhalten)?">
          <v-expansion-panel-text>
            <p class="mb-3">In der neotivTrials-App werden, je nach Studie, verschiedene Arten von Tests, die darauf ausgelegt sind, spezifische kognitive Fähigkeiten zu messen, als auch verschiedene Fragebögen verwendet.</p>
            <p class="mb-3">Wir verstehen, dass einige Tests herausfordernd oder ungewohnt sein können. Lassen Sie sich davon bitte nicht entmutigen. Es ist normal, dass nicht alle Aufgaben gleichermaßen gut abgeschlossen werden können. Das Wichtigste ist, dass Sie Ihr Bestes geben und die Tests vollständig abschließen.</p>
            <p class="mb-3">Falls Sie Feedback zu den Testinhalten haben, z. B. zur Schwierigkeit, der Verständlichkeit der Anweisungen, lassen Sie es uns bitte wissen. Verwenden Sie dazu die <b>Fehlerberichterstattungsfunktion</b> (siehe Seite 2: „Wie melde ich ein Problem mit der App und sende einen Fehlerbericht?“) oder schreiben Sie eine E-Mail an <a href="mailto:support@neotiv.com">support@neotiv.com</a>. Bitte geben Sie an, auf welche Studie Sie sich beziehen.</p>
            <p class="mb-3">Ihr Feedback hilft uns, die Tests weiterzuentwickeln und unsere Fragebögen zu optimieren.</p>
            <p class="mb-3">Sollten bei Ihnen Fragen auftreten, die nicht die neotivTrials-App betreffen, sondern andere Aspekte der Studie, wenden Sie sich bitte an Ihre Studienkoordination.</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel title="Wie kann ich meine Teilnahme beenden, bevor die Studie zu Ende ist?">
          <v-expansion-panel-text>
            <p class="mb-3">
              Als Teilnehmende einer Studie, die neotivTrials-App nutzt, haben Sie das Recht, Ihre Teilnahme jederzeit zu beenden. Natürlich hoffen wir, dass Sie bis zum Ende der Studie dabeibleiben, da vollständige Datensätze für die Forschung sehr wertvoll sind. Wir respektieren jedoch Ihre
              Entscheidung, wenn Sie die Studie vorzeitig verlassen möchten.
            </p>
            <p class="mb-3">Um sich aus der Studie abzumelden, wenden Sie sich bitte an Ihre Studienkoordination.</p>
            <p class="mb-3"><b>Bitte beachten Sie:</b> Bereits gesammelte Daten werden in anonymisierter Form gespeichert. Wenn Sie möchten, dass diese Daten ebenfalls gelöscht werden, geben Sie dies bitte ausdrücklich per E- Mail an.</p>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
      </v-container>
    </section>


    <!-- Contact form -->
    <section class="contact bg-primary">
      <v-container class="py-12">
        <v-container>
          <h3 class="text-white text-center">
            Ihr Kontakt für technische Fragen
          </h3>
          <p class="text-white mt-7">
            Bei technischen Fragen oder Problemen schreiben Sie uns eine E-Mail an: support@neotiv.com
          </p>
        </v-container>
        <contact-form
          :formColor="'#57509C'"
          :formBtnColor="'#6DC1B9'"
          :newsletter="false"
        />
      </v-container>
    </section>
    <!-- Fullscreen Dialog with Video -->
    <v-dialog v-model="dialog" max-width="960" max-height="700" persistent @click:outside="dialog = false">
      <v-card class="pa-4">
        <video
          controls
          autoplay
          width="100%"
          height="700"
          :src="activeVideo"
        ></video>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ContactForm from "@/components/Form";
import {nextTick} from 'vue'

export default {
  components: {
    ContactForm
  },
  data () {
    return {
      activeVideo: '',
      dialog: false
    }
  },
  computed: {
    appStartVideo() {
      return require("@/assets/videos/app-start.mp4")
    },
    bugReportVideo() {
      return require("@/assets/videos/bug-report.mp4")
    },
    downloadAndroidVideo() {
      return require("@/assets/videos/download-android.mp4")
    },
    downloadAppleVideo() {
      return require("@/assets/videos/download-apple.mp4")
    }
  },
  methods: {
    scrollToTipps () {
      const element = document.querySelector('.tipps')
      element.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToBlick () {
      const element = document.querySelector('.blick')
      element.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToInfoTrials () {
      const element = document.querySelector('.infoNeotivTrials')
      element.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToSupport () {
      const element = document.querySelector('.support')
      element.scrollIntoView({ behavior: 'smooth' })
    },
    openVideo (videoSrc) {
      this.activeVideo = videoSrc
      this.dialog = true
    }
  }
};
</script>

<style scoped>
.pred {
  color: #B00020;
}

.violet {
  color: #57509c;
}

.v-expansion-panel-text {
  max-height: 500px;
  overflow-y: auto;
}

video {
  background-color: var(--v-videoBackgroundColor-base);
  border: 1px solid var(--v-videoBackgroundColor-base);
}

.hero-title {
  font-size: 40px;
  line-height: 1.25;
}

.hero-text {
  font-size: 24px;
  line-height: 1.25;
  color: #57509C;
}

@media only screen and (max-width: 600px) {
  .hero-title {
    font-size: 30px;
  }
}

.more-btn {
  top: -80px;
  font-size: 18px !important;
}

h1 {
  font-size: 38px;
}

ul {
  line-height: 1.75em;
}

body {
  font-family: 'Source Sans', sans-serif;
}

.video-wrapper {
  position: relative;
  width: 100%;
  height: 400px;
  cursor: pointer;
  overflow: hidden;
}

.inline-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none; /* Prevent native controls from triggering */
}

</style>
